import axios from 'axios';
import { getToken, scopeForRequest } from './session';

/**
 * Centralized Axios API module
 *
 * To configure the server URL, set the REACT_APP_API_URL environment variable.
 * For example, create a .env file in the client directory with:
 *   REACT_APP_API_URL=http://localhost:5000
 *
 * If REACT_APP_API_URL is not set, it defaults to an empty string,
 * which means requests will use the current origin (same domain).
 *
 * This module automatically:
 * - Attaches the Authorization header for whichever panel is making the call
 * - Handles error responses
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request interceptor.
 *
 * The admin console and merchant portal hold separate sessions, so the token is
 * chosen per request rather than read from one shared key: the API prefix
 * decides where it can, otherwise the panel currently on screen does.
 */
api.interceptors.request.use(
  (config) => {
    const scope = scopeForRequest(
      config.url || '',
      typeof window !== 'undefined' ? window.location.pathname : ''
    );
    const token = scope ? getToken(scope) : null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling. Each panel's layout registers its
// own 401 handler so it can redirect to the right login screen.
api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default api;
